import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Category } from "../types";

type GetCategoriesParams = {
	locale?: string;
	portalUid: string;
};

const fetchCategories = async (locale: string = "en-us", portalUid: string): Promise<Category[]> => {
	const response = await apiDal.post("/queries/public/fetch", {
		query: "getCategories",
		bind: {
			locale: locale.toLowerCase(),
			enterpriseUid: portalUid,
		},
	}); 
	return response.data.result;
};

export const useGetCategoriesByEnterpriseUid = ({ locale, portalUid }: GetCategoriesParams) => {
	return useQuery<Category[]>({
		queryKey: ["getCategoriesV2", locale, portalUid],
		queryFn: () => fetchCategories(locale, portalUid),
		enabled: !!portalUid,
		initialData: []
	});
};
